export default __webpack_public_path__ + "static/media/ico-sq-1-poverty.c49169f9.svg";